module.exports = __webpack_public_path__ + "static/pic09-61bd217dbb53fd465dacd570c664dc03.jpg";